import { defineStore } from 'pinia'

import { getHeaderCalls } from '@/api/headers-routes'

import { useDefaultStore } from '@/store/defaultStore'

export const useHeaderMetricsStore = defineStore('headerMetricsStore', {
    state: () => ({
        liveCalls: 0,
        totalCalls: 0,
    }),

    actions: {
        async loadHeaderCalls() {
            const { success, payload, message } = await getHeaderCalls()

            if (success) {
                this.setHeaderCalls(payload)
            } else {
                useDefaultStore().setErrorMessage(message)
            }
        },

        setHeaderCalls(payload) {
            if (!payload) {
                return
            }

            const { live = 0, completed = 0 } = payload

            this.liveCalls = live
            this.totalCalls = completed
        },

        reset() {
            this.liveCalls = 0
            this.totalCalls = 0
        },
    },
})
